import { render } from "./HomepageLayout.vue?vue&type=template&id=60cec35a&scoped=true"
import script from "./HomepageLayout.vue?vue&type=script&lang=js"
export * from "./HomepageLayout.vue?vue&type=script&lang=js"

import "./HomepageLayout.vue?vue&type=style&index=0&id=60cec35a&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60cec35a"]])

export default __exports__